import MoveTo from 'moveto';

/**
 * Eksodi 99 hero slider.
 *
 * Two responsibilities:
 *  1. Auto-rotate slides (crossfade) like the home hero. Pauses while any
 *     Read more panel is expanded so the visitor can finish reading.
 *  2. Toggle the matching long-form panel that lives in its own full-width
 *     section below the hero — clicking Read more on slide N reveals the
 *     panel with the same data-slide-index.
 */

const initEksodiSlider = () => {
  const slider = document.querySelector('[data-eksodi-slider]');
  if (!slider) {
    return;
  }

  const slides = slider.querySelectorAll('.eksodi-hero-slide');
  const toggles = slider.querySelectorAll('[data-readmore-toggle]');
  const longs = document.querySelector('[data-eksodi-longs]');
  const panels = longs
    ? longs.querySelectorAll('[data-readmore-body]')
    : [];

  const panelByIndex = new Map();
  panels.forEach(panel => {
    const idx = Number.parseInt(panel.dataset.slideIndex, 10);
    if (!Number.isNaN(idx)) {
      panelByIndex.set(idx, panel);
    }
  });

  const prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const moveTo = new MoveTo({
    duration: prefersReducedMotion ? 0 : 900,
    easing: 'easeInOutCubic',
    tolerance: 0,
  }, {
    easeInOutCubic(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t * t + b;
      t -= 2;
      return (c / 2) * (t * t * t + 2) + b;
    },
  });

  const closeAllPanels = () => {
    panels.forEach(panel => {
      panel.hidden = true;
      panel.classList.remove('is-expanded');
    });
    toggles.forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = btn.dataset.labelMore || 'Read more';
    });
  };

  toggles.forEach(button => {
    const idx = Number.parseInt(button.dataset.slideIndex, 10);
    const panel = panelByIndex.get(idx);
    if (!panel) {
      return;
    }

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      const next = !expanded;

      // Collapse any other expanded panel first so only one is open.
      closeAllPanels();

      if (next) {
        panel.hidden = false;
        // Force reflow so the CSS animation re-triggers on re-open.
        // eslint-disable-next-line no-unused-expressions
        panel.offsetHeight;
        panel.classList.add('is-expanded');
        button.setAttribute('aria-expanded', 'true');
        button.textContent = button.dataset.labelLess || 'Read less';

        // Smooth scroll the panel into view with custom easing.
        window.requestAnimationFrame(() => {
          moveTo.move(panel);
        });
      }
    });
  });

  if (!slides || slides.length < 2) {
    return;
  }

  const intervalFromData = Number.parseInt(slider.dataset.interval, 10);
  const interval = Number.isNaN(intervalFromData) ? 6000 : intervalFromData;
  let currentIndex = 0;

  const setActiveSlide = nextIndex => {
    slides.forEach((slide, index) => {
      const isActive = index === nextIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  };

  const hasExpandedPanel = () =>
    !!(longs && longs.querySelector('[data-readmore-body].is-expanded'));

  window.setInterval(() => {
    if (hasExpandedPanel()) {
      return;
    }
    currentIndex = (currentIndex + 1) % slides.length;
    setActiveSlide(currentIndex);
  }, interval);
};

export default initEksodiSlider;
